export default __webpack_public_path__ + "static/media/Money-background.9f79a55a.svg";